import React, { useContext, useState } from "react";
import { Col, Container, Row, Card, CardHeader } from "reactstrap";
import "leaflet/dist/leaflet.css";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import "../utils/style.css";
import InspectionUser from "./InspectionUser.js";
import IncidentUser from "./IncidentUser.js";
import OldVehicle from "./OldVehicle";
import ResumeDriver from "./ResumeDriver";
import ProfileImage from "../../Profiles/components/ProfileImage.js";
import { CarOutlined } from "@ant-design/icons";
import Documents from "./Document";
import { getDriverById } from "../services/driverApi.js";

const DetailDriver = () => {
  const history = useContext(HistoryContext);
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("Résumé");

  const {
    data: user,
    isLoading: loadingUser,
    isError: isErrorUser,
    error: errorUser,
  } = useQuery(["user", id], () => getDriverById(id), {
    enabled: !!id,
  });

  const tabs = [ "Résumé", "Inspections", "Incidents", "Anciens véhicules", "Documents"];

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  
  const getStatusColor = (status) => {
    switch (status) {
      case "Actif":
      case "En service #2FB550":
      case "Actif #2FB550":
        return "#2FB550";
      case "Inactif":
        return " #FF2D55";
      default:
        return " #FF9500";
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb page="Détail véhicule" history={history} />
          <Card>
            <div className="imgVehicle mt-2">
              <ProfileImage user={user} size={150} />
              <div className="text-center">
                <span className="nameVehicle">{user?.name || "-"}</span>
                <span
                  className="statut"
                  style={{
                    backgroundColor: getStatusColor(user?.status),
                    display: "inline-flex",
                    alignItems: "center",
                    marginRight: "200px",
                  }}
                >
                  <span
                    className="statut"
                    style={{
                      marginRight: "14px",
                      backgroundColor: getStatusColor(user?.status),
                    }}
                  />
                  {user?.status || "-"}
                  <span className="titleStatut">{user?.email}</span>
                </span>
              </div>
            </div>
            <hr className="hr" />
            <Row>
              <Col lg={12}>
                <div className="tab-container">
                  <button className="big-button">
                    <div className="tab-container-wrapper">
                      {tabs.map((tab) => (
                        <button
                          key={tab}
                          className={`tab-button ${
                            activeTab === tab ? "active" : ""
                          }`}
                          onClick={() => handleTabChange(tab)}
                        >
                          {tab}
                        </button>
                      ))}
                    </div>
                  </button>
                </div>
              </Col>
              <Col lg={12}>{activeTab === "Résumé" && <ResumeDriver />}</Col>
              <Col lg={2}></Col>
              <Col lg={8}>
                {activeTab === "Inspections" && user && (
                  <InspectionUser user={user} />
                )}
                {activeTab === "Incidents" && user && (
                  <IncidentUser user={user} />
                )}
                {activeTab === "Anciens véhicules" && user && (
                  <OldVehicle user={user} />
                )}
                {activeTab === "Documents" && user && <Documents user={user} />}
              </Col>
              <Col lg={2}></Col>
            </Row>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DetailDriver;
